import PropTypes from 'prop-types';

const withLocale = Component => {
  if (!Component.contextTypes) {
    Component.contextTypes = {};
  }

  Component.contextTypes.locale = PropTypes.func;

  return Component;
};

export default withLocale;



// WEBPACK FOOTER //
// ./src/decorators/with-locale.js